import React from 'react';
import moment from 'moment';
import { isUserSubscribed } from '@helpers';
import { User } from '@teachur/http-client';

interface SubscriptionStatusProps {
  user: User;
  subscription?: StripeSubscription;
}

export const DATE_FORMAT = 'YYYY-MM-DD';

export const SubscriptionStatus: React.FC<SubscriptionStatusProps> = ({ user, subscription }) => {
  return (
    <>
      <p>
        Subscription status:{' '}
        {isUserSubscribed(user) ? (
          <span className="text-success">ACTIVE</span>
        ) : (
          <span className="text-danger">NOT SUBSCRIBED</span>
        )}
      </p>
      {subscription && subscription.cancelAtPeriodEnd && subscription.currentPeriodEnd ? (
        <p style={{ color: 'red' }}>
          Subscription will be paused on:{' '}
          {moment.unix(subscription.currentPeriodEnd).format(DATE_FORMAT)}
        </p>
      ) : null}{' '}
    </>
  );
};
